import { ChangeDetectionStrategy, Component, computed, forwardRef, input, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { LinkableLocationsService, LocationGroup, ProfileLocation } from 'src/app/api/linkable-locations.service';
import { PreferencesService } from 'src/app/preferences.service';
import { IconService } from '../../icon.service';
import { LocationDisplayPipe } from '../../pipes/location-display.pipe';
import { TagModule } from 'primeng/tag';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MultiSelectModule } from 'primeng/multiselect';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-location-multi-dropdown',
  templateUrl: './location-multi-dropdown.component.html',
  styleUrls: ['./location-multi-dropdown.component.scss'],
  imports: [ReactiveFormsModule, LocationDisplayPipe, TagModule, FontAwesomeModule, MultiSelectModule, ButtonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LocationMultiDropdownComponent),
      multi: true
    }
  ]
})
export class LocationMultiDropdownComponent implements OnInit {

  value: ProfileLocation[] | null = null
  onChange: any = () => { };
  onTouched: any = () => { };
  disabled = false;
  touched = false;

  form = new FormGroup({
    location: new FormControl<ProfileLocation[]>([])
  })


  options = input<ProfileLocation[]>([])
  

  
  locationGroups = input<LocationGroup[]>([])
  includeStandardLocationGroups = input<boolean>(true)


  sortedOptions = computed(() => {
    return this.options().sort((a, b) => a.name.localeCompare(b.name))
  })


  defaultLocationGroups = computed(() => {
    const locations = this.options()

    return [
      {
        label: 'Domestic Locations',
        locations: locations.filter(loc => loc.domestic === 1)
      },
      {
        label: 'International Locations',
        locations: locations.filter(loc => loc.domestic === 0)
        }
      ]
    
  })

  locationGroupsInternal = computed(() => {
    const locationGroups = this.locationGroups()
    const standardLocationGroups = this.defaultLocationGroups()

    if (locationGroups.length > 0) {
      if (this.includeStandardLocationGroups()) {
        return [...standardLocationGroups, ...locationGroups]
      }
      return locationGroups
    }
   else {
    if (this.includeStandardLocationGroups()) {
      return standardLocationGroups
    }
    return []
    }
  })


  constructor(
    public icons: IconService,
    private locationService: LinkableLocationsService,
    public preferences: PreferencesService
  ) {

  }

  ngOnInit(): void {
    this.form.valueChanges.subscribe(changes => {
      this.value = changes.location ? changes.location : null
      this.onChange(this.value)
    })
  }

  writeValue(obj: any): void {
    this.value = obj
    this.form.setValue({ location: obj }, { emitEvent: false })
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled
    isDisabled ? this.form.disable() : this.form.enable()

  }

  removeItem(location: ProfileLocation) {
    this.markAsTouched()
    this.value = this.value?.filter(l => l.id !== location.id) ?? []
    this.form.controls.location.setValue(this.value)
    this.onChange(this.value)
  }

  valueChange() {
    this.markAsTouched()

  }

  onInputBlur() {
    this.markAsTouched()
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true
    }
  }

  selectGroup(group: LocationGroup) {
    const newValues = [...group.locations];
    const currentIds = this.form.controls.location.value?.map(l => l.id) ?? []

    this.form.controls.location.setValue(newValues.filter(l => !currentIds.includes(l.id)));
  }

}
